import { KoTag } from 'packages';

// ── HTTP Method Config ─────────────────────────────────────────
export const HTTP_METHODS = {
  GET: 'GET', POST: 'POST', PUT: 'PUT', PATCH: 'PATCH',
  DELETE: 'DELETE', HEAD: 'HEAD', OPTIONS: 'OPTIONS'
};

export const HTTP_METHOD_CONFIG = {
  GET:     { color: 'success',    label: 'GET' },
  POST:    { color: 'processing', label: 'POST' },
  PUT:     { color: 'warning',    label: 'PUT' },
  PATCH:   { color: 'cyan',      label: 'PATCH' },
  DELETE:  { color: 'error',      label: 'DELETE' },
  HEAD:    { color: 'purple',     label: 'HEAD' },
  OPTIONS: { color: 'default',    label: 'OPTIONS' }
};

export const HTTP_METHOD_OPTIONS = [
  { label: 'GET', value: 'GET' },
  { label: 'POST', value: 'POST' },
  { label: 'PUT', value: 'PUT' },
  { label: 'PATCH', value: 'PATCH' },
  { label: 'DELETE', value: 'DELETE' },
  { label: 'HEAD', value: 'HEAD' },
  { label: 'OPTIONS', value: 'OPTIONS' }
];

// ── Service Status Config ──────────────────────────────────────
export const SERVICE_STATUS = {
  ACTIVE: 'active', DEPRECATED: 'deprecated', RETIRED: 'retired', DRAFT: 'draft'
};

export const SERVICE_STATUS_CONFIG = {
  active:     { color: 'success',    label: 'Active' },
  deprecated: { color: 'warning',    label: 'Deprecated' },
  retired:    { color: 'default',    label: 'Retired' },
  draft:      { color: 'processing', label: 'Draft' }
};

export const SERVICE_STATUS_OPTIONS = [
  { label: 'Active', value: 'active' },
  { label: 'Deprecated', value: 'deprecated' },
  { label: 'Retired', value: 'retired' },
  { label: 'Draft', value: 'draft' }
];

// ── Endpoint Status Config ─────────────────────────────────────
export const ENDPOINT_STATUS_CONFIG = {
  active:     { color: 'success',    label: 'Active' },
  deprecated: { color: 'warning',    label: 'Deprecated' },
  draft:      { color: 'processing', label: 'Draft' },
  breaking:   { color: 'magenta',    label: 'Breaking' }
};

export const ENDPOINT_STATUS_OPTIONS = [
  { label: 'Active', value: 'active' },
  { label: 'Deprecated', value: 'deprecated' },
  { label: 'Draft', value: 'draft' },
  { label: 'Breaking', value: 'breaking' }
];

// ── Auth Type Config ───────────────────────────────────────────
export const AUTH_TYPE_CONFIG = {
  none:   { label: 'None',       icon: 'StopOutlined' },
  apiKey: { label: 'API Key',    icon: 'KeyOutlined' },
  bearer: { label: 'Bearer',     icon: 'SafetyOutlined' },
  oauth2: { label: 'OAuth 2.0',  icon: 'LockOutlined' },
  basic:  { label: 'Basic Auth', icon: 'UserOutlined' }
};

export const AUTH_TYPE_OPTIONS = [
  { label: 'None', value: 'none' },
  { label: 'API Key', value: 'apiKey' },
  { label: 'Bearer Token', value: 'bearer' },
  { label: 'OAuth 2.0', value: 'oauth2' },
  { label: 'Basic Auth', value: 'basic' }
];

// ── Change Type Config (Contract Diff) ─────────────────────────
export const CHANGE_TYPE_CONFIG = {
  added:      { color: 'success',  label: 'Added' },
  modified:   { color: 'warning',  label: 'Modified' },
  removed:    { color: 'error',    label: 'Removed' },
  deprecated: { color: 'default',  label: 'Deprecated' },
  breaking:   { color: 'magenta',  label: 'Breaking' }
};

// ── Test Result Config ─────────────────────────────────────────
export const TEST_RESULT_CONFIG = {
  passed:  { color: 'success',    label: 'Passed' },
  failed:  { color: 'error',      label: 'Failed' },
  skipped: { color: 'default',    label: 'Skipped' },
  running: { color: 'processing', label: 'Running' }
};

// ── Audit Action Config ────────────────────────────────────────
export const AUDIT_ACTION_CONFIG = {
  created:         { color: 'success',    label: 'Created' },
  updated:         { color: 'warning',    label: 'Updated' },
  deleted:         { color: 'error',      label: 'Deleted' },
  deployed:        { color: 'processing', label: 'Deployed' },
  deprecated:      { color: 'default',    label: 'Deprecated' },
  version_changed: { color: 'purple',     label: 'Version Changed' }
};

// ── Select Options ─────────────────────────────────────────────
export const CONTENT_TYPE_OPTIONS = [
  { label: 'application/json', value: 'application/json' },
  { label: 'application/xml', value: 'application/xml' },
  { label: 'text/plain', value: 'text/plain' },
  { label: 'multipart/form-data', value: 'multipart/form-data' },
  { label: 'application/x-www-form-urlencoded', value: 'application/x-www-form-urlencoded' }
];

export const ENVIRONMENT_TYPE_OPTIONS = [
  { label: 'Development', value: 'development' },
  { label: 'Staging', value: 'staging' },
  { label: 'Production', value: 'production' },
  { label: 'Custom', value: 'custom' }
];

export const ENVIRONMENT_TYPE_CONFIG = {
  development: { color: 'processing', label: 'Development' },
  staging:     { color: 'warning',    label: 'Staging' },
  production:  { color: 'success',    label: 'Production' },
  custom:      { color: 'default',    label: 'Custom' }
};

export const PROTOCOL_OPTIONS = [
  { label: 'REST', value: 'REST' },
  { label: 'GraphQL', value: 'GraphQL' },
  { label: 'gRPC', value: 'gRPC' },
  { label: 'WebSocket', value: 'WebSocket' }
];

export const VERSION_STRATEGY_OPTIONS = [
  { label: 'URL Path (/v1/)', value: 'url_path' },
  { label: 'Header', value: 'header' },
  { label: 'Query Param', value: 'query_param' }
];

// ── Column Definitions ─────────────────────────────────────────

export const COLUMNS_SERVICES = [
  { label: 'Name', id: 'name', key: 'name', width: 180 },
  { label: 'Base URL', id: 'baseUrl', key: 'baseUrl', width: 220,
    render: (val) => <span style={{ fontFamily: 'monospace', fontSize: '1.2rem' }}>{val || '—'}</span> },
  { label: 'Protocol', id: 'protocol', key: 'protocol', width: 100 },
  { label: 'Version', id: 'version', key: 'version', width: 80 },
  { label: 'Owner', id: 'owner', key: 'owner', width: 120 },
  { label: 'Status', id: 'status', key: 'status', width: 110,
    render: (val) => {
      const cfg = SERVICE_STATUS_CONFIG[val] || {};
      return <KoTag color={cfg.color}>{cfg.label || val}</KoTag>;
    }
  },
  { label: 'Endpoints', id: 'endpointsCount', key: 'endpointsCount', width: 90 },
  { label: 'Updated', id: 'updatedAt', key: 'updatedAt', width: 140 }
];

export const COLUMNS_ENDPOINTS = [
  { label: 'Method', id: 'method', key: 'method', width: 90,
    render: (val) => {
      const cfg = HTTP_METHOD_CONFIG[val] || {};
      return <KoTag color={cfg.color}>{cfg.label || val}</KoTag>;
    }
  },
  { label: 'Path', id: 'path', key: 'path', width: 240,
    render: (val) => <span style={{ fontFamily: 'monospace', fontSize: '1.2rem' }}>{val || '—'}</span> },
  { label: 'Summary', id: 'summary', key: 'summary', width: 200 },
  { label: 'Service', id: 'serviceName', key: 'serviceName', width: 140 },
  { label: 'Auth', id: 'authType', key: 'authType', width: 100,
    render: (val) => AUTH_TYPE_CONFIG[val]?.label || val || 'None' },
  { label: 'Status', id: 'status', key: 'status', width: 100,
    render: (val) => {
      const cfg = ENDPOINT_STATUS_CONFIG[val] || {};
      return <KoTag color={cfg.color}>{cfg.label || val}</KoTag>;
    }
  },
  { label: 'Version', id: 'version', key: 'version', width: 80 },
  { label: 'Avg Response', id: 'avgResponseTime', key: 'avgResponseTime', width: 110,
    render: (val) => val ? `${val}ms` : '—' }
];

export const COLUMNS_COLLECTIONS = [
  { label: 'Name', id: 'name', key: 'name', width: 200 },
  { label: 'Description', id: 'description', key: 'description', width: 240 },
  { label: 'Endpoints', id: 'endpointsCount', key: 'endpointsCount', width: 100 },
  { label: 'Version', id: 'version', key: 'version', width: 80 },
  { label: 'Owner', id: 'owner', key: 'owner', width: 120 },
  { label: 'Last Run', id: 'lastRun', key: 'lastRun', width: 140 },
  { label: 'Updated', id: 'updatedAt', key: 'updatedAt', width: 140 }
];

export const COLUMNS_ENVIRONMENTS = [
  { label: 'Name', id: 'name', key: 'name', width: 160 },
  { label: 'Type', id: 'type', key: 'type', width: 120,
    render: (val) => {
      const cfg = ENVIRONMENT_TYPE_CONFIG[val] || {};
      return <KoTag color={cfg.color}>{cfg.label || val}</KoTag>;
    }
  },
  { label: 'Base URL', id: 'baseUrl', key: 'baseUrl', width: 240,
    render: (val) => <span style={{ fontFamily: 'monospace', fontSize: '1.2rem' }}>{val || '—'}</span> },
  { label: 'Variables', id: 'variablesCount', key: 'variablesCount', width: 100 },
  { label: 'Owner', id: 'owner', key: 'owner', width: 120 },
  { label: 'Updated', id: 'updatedAt', key: 'updatedAt', width: 140 }
];

export const COLUMNS_CONTRACT_DIFF = [
  { label: 'Field / Path', id: 'path', key: 'path', width: 240,
    render: (val) => <span style={{ fontFamily: 'monospace', fontSize: '1.2rem' }}>{val || '—'}</span> },
  { label: 'Change', id: 'changeType', key: 'changeType', width: 120,
    render: (val) => {
      const cfg = CHANGE_TYPE_CONFIG[val] || {};
      return <KoTag color={cfg.color}>{cfg.label || val}</KoTag>;
    }
  },
  { label: 'Before', id: 'before', key: 'before', width: 200,
    render: (val) => <span style={{ fontFamily: 'monospace', fontSize: '1.2rem' }}>{val ?? '—'}</span> },
  { label: 'After', id: 'after', key: 'after', width: 200,
    render: (val) => <span style={{ fontFamily: 'monospace', fontSize: '1.2rem' }}>{val ?? '—'}</span> },
  { label: 'Breaking', id: 'breaking', key: 'breaking', width: 90,
    render: (val) => val
      ? <span style={{ color: '#f5222d', fontWeight: 600 }}>Yes</span>
      : <span style={{ color: '#8c8c8c' }}>No</span>
  }
];

export const COLUMNS_RELEASE_TESTS = [
  { label: 'Suite Name', id: 'name', key: 'name', width: 200 },
  { label: 'Service', id: 'serviceName', key: 'serviceName', width: 140 },
  { label: 'Endpoints', id: 'endpointsCount', key: 'endpointsCount', width: 100 },
  { label: 'Passed', id: 'passed', key: 'passed', width: 80,
    render: (val) => <span style={{ color: '#52c41a', fontWeight: 600 }}>{val ?? 0}</span> },
  { label: 'Failed', id: 'failed', key: 'failed', width: 80,
    render: (val) => <span style={{ color: val > 0 ? '#f5222d' : '#8c8c8c', fontWeight: 600 }}>{val ?? 0}</span> },
  { label: 'Skipped', id: 'skipped', key: 'skipped', width: 80 },
  { label: 'Status', id: 'status', key: 'status', width: 110,
    render: (val) => {
      const cfg = TEST_RESULT_CONFIG[val] || {};
      return <KoTag color={cfg.color}>{cfg.label || val}</KoTag>;
    }
  },
  { label: 'Duration', id: 'duration', key: 'duration', width: 100,
    render: (val) => val ? `${val}s` : '—' },
  { label: 'Last Run', id: 'lastRun', key: 'lastRun', width: 140 }
];

export const COLUMNS_AUDIT_LOGS = [
  { label: 'Timestamp', id: 'timestamp', key: 'timestamp', width: 170 },
  { label: 'Action', id: 'action', key: 'action', width: 130,
    render: (val) => {
      const cfg = AUDIT_ACTION_CONFIG[val] || {};
      return <KoTag color={cfg.color}>{cfg.label || val}</KoTag>;
    }
  },
  { label: 'Entity', id: 'entityType', key: 'entityType', width: 120 },
  { label: 'Name', id: 'entityName', key: 'entityName', width: 180 },
  { label: 'User', id: 'user', key: 'user', width: 140 },
  { label: 'Details', id: 'details', key: 'details', width: 220,
    render: (val) => <span style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }}>{val || '—'}</span> },
  { label: 'Version', id: 'version', key: 'version', width: 80 }
];
